module.exports = [{"title":"грн","symbol":"₴","translit":"uah","slug":"uah","id":1917},{"title":"$","symbol":"$","translit":"usd","slug":"usd","currency":"usd","id":1915},{"title":"€","symbol":"€","translit":"eur","slug":"eur","currency":"eur","id":1916}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/currency.json
// module id = 132
// module chunks = 49